import { useInspectionResultStore } from '@/stores/inspectionResultUpsertStore'
import type { ObjectStoreName } from '@/types/accessor/indexedDB'
import { decrypt, encrypt } from '@/utils/cryptography/cryptography'
import { getItem, removeItem, setItem } from './sessionStorage'

const STORE_NAME: ObjectStoreName = 'inspector_list'

/**
 * 直前の調査情報登録
 */
export const setInspectorList = () => {
  const inspectionResultStore = useInspectionResultStore()
  const inspectorList = inspectionResultStore.assessmentInfo.inspectorList
  const encryptInspectorList = encrypt(inspectorList, STORE_NAME)
  setItem(STORE_NAME, { encryptInspectorList, savedAt: new Date().toISOString().slice(0, 10) })
}

/**
 * 直前の調査情報取得
 */
export const getInspectorList = (): string[] => {
  const inspectorObject: { encryptInspectorList: string } | null = getItem(STORE_NAME)
  if (inspectorObject == null) {
    return []
  }
  try {
    const result = decrypt(inspectorObject.encryptInspectorList, STORE_NAME)
    return Array.isArray(result) ? (result as string[]) : []
  } catch {
    // 復元・パースに失敗した場合は空配列を返す
    console.error('調査員の復元に失敗しました')
    return []
  }
}

/**
 * 直前の調査情報が前日のものであれば削除する
 */
export const checkFirstOfTheDay = () => {
  const inspectorObject = getItem(STORE_NAME)
  if (inspectorObject?.savedAt == null) return

  const savedAt = inspectorObject.savedAt
  const today = new Date().toISOString().slice(0, 10)
  if (savedAt !== today) {
    removeInspectorList()
  }
}

/**
 * 直前の調査情報削除
 */
export const removeInspectorList = () => {
  removeItem(STORE_NAME)
}
